import { IScript } from '../models/IScript';
import { IStore } from '../redux/initialState';
import { routeInfo } from '../routeInfo';
import getUrlInfo from '../services/mini/getUrlInfo';
import store from '../store';
import history from '../history';
import * as scriptEditorActions from '../redux/scriptEditor/actions.scriptEditor';
import * as _ from 'lodash';
import { transformsStore } from '../mobx/transforms.store';

window.alan_openTransforms = function (transformName, indexArr) {
    const { projectName } = getUrlInfo();
    const project = (store.getState() as IStore).projectsInfo?.currentProject;

    console.info('alan_openTransforms', transformName, indexArr);

    const transform: IScript = _.find(project.scripts, { name: transformName, type: 'transform' });

    if (transform) {
        const newUrl = routeInfo.projectScripts.url(projectName, transformName);
        transformsStore.setLineFilters(indexArr || []);
        history.push(newUrl);
    } else {
        console.warn(`${transformName} does not exist in the project`);
    }
};

window.alan_openScript = function (scriptName, lineNumber) {
    const project = (store.getState() as IStore).projectsInfo?.currentProject;

    console.info('alan_openScript', scriptName, lineNumber);

    store.dispatch(scriptEditorActions.highlightLine({
        project,
        scriptName,
        lineNumber,
        character: 0
    }));
};

window.alan_openTransform = function (transformName, index) {
    const { projectName } = getUrlInfo();
    const project = (store.getState() as IStore).projectsInfo?.currentProject;

    console.info('alan_openTransform', transformName, index);
    const transform: IScript = _.find(project.scripts, { name: transformName, type: 'transform' });

    if (transform) {
        const newUrl = routeInfo.projectScripts.url(projectName, transformName);
        transformsStore.setLineFilters([index]);
        history.push(newUrl);
    } else {
        console.warn(`${transformName} does not exist in the project`);
    }
};